import React from 'react';
import type { MarketProfileState } from '../marketProfileStore';
import { computeProgress } from '../marketProfileStore';
import MarketDataLockedState from './MarketDataLockedState';
import MarketDataOpenDashboard from './MarketDataOpenDashboard';

type Props = {
  state: MarketProfileState;
  onGoOverview: () => void;
  onOpenPosition?: () => void;
  onOpenGrading?: () => void;
  onConfirmReview?: () => void;
};

export default function MarketDataTab({
  state,
  onGoOverview,
  onOpenPosition,
  onOpenGrading,
  onConfirmReview,
}: Props) {
  const progress = computeProgress(state);
  const dataReady = progress.completed === 2;

  if (!dataReady) {
    return (
      <MarketDataLockedState
        state={state}
        completed={progress.completed}
        submitted={progress.submitted}
        onGoFill={onGoOverview}
        onOpenPosition={onOpenPosition}
        onOpenGrading={onOpenGrading}
      />
    );
  }

  return (
    <MarketDataOpenDashboard
      state={state}
      confirmed={Boolean(state.confirmedAt)}
      onConfirmReview={!state.confirmedAt ? onConfirmReview : undefined}
    />
  );
}
